import React, { Component } from 'react';
import Layout from '../../Layout/layout';
import Helmet from 'react-helmet';
import { Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { apiHost } from '../../api/apiClient';
import {setLoadingPage,setErrorMessage} from '../../reducers/actions';
import { connect } from 'react-redux';
import EventTable from './eventTable';
import '../../styles/events/events.scss';
import RoleAccessBadge from "../common/roleAccessBadge";

class Events extends Component {
    constructor(props){
        super(props);
        this.state={
            eventList:[],
            searchKey: "",
            statusFilter: "all",
        }
    }
    componentDidMount(){
let urlEvents= `${apiHost}/api/Event/AllEvents`;
this.getEvents(urlEvents);
    }

    getEvents=async(url)=>{
        this.props.setLoadingPageAction(true);
        try {
            let EventsList = await axios.get(url, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            });
            console.log("events", EventsList);
            this.setState({
                eventList: EventsList.data
           
            });
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
             }else{
                this.props.setErrorMessageAction(`${e}`)
   
              }
          this.props.setLoadingPageAction(false);
        
            console.log(`😱 Axios request failed: ${e}`);
          

    }
}
handleCreateNew=()=>{
    this.props.history.push('/create-new-event');
}

normalizeStatus = (status) => {
    const normalizedStatus = (status || "").toString().toLowerCase();

    if (normalizedStatus === "active" || normalizedStatus === "1") {
        return "active";
    }

    if (normalizedStatus === "disabled" || normalizedStatus === "disable" || normalizedStatus === "0") {
        return "disabled";
    }

    return "unknown";
}

getStatusCounts = () => {
    return this.state.eventList.reduce(
        (counts, event) => {
            const status = this.normalizeStatus(event.status);

            counts.all += 1;

            if (status === "active") {
                counts.active += 1;
            }

            if (status === "disabled") {
                counts.disabled += 1;
            }

            return counts;
        },
        { all: 0, active: 0, disabled: 0 }
    );
}

getFilteredEvents = () => {
    const searchKey = this.state.searchKey.trim().toLowerCase();

    return this.state.eventList.filter((event) => {
        const status = this.normalizeStatus(event.status);
        const statusMatches = this.state.statusFilter === "all" || status === this.state.statusFilter;
        const searchMatches =
            !searchKey ||
            [
                event.name,
                event.description,
                event.type,
                event.config,
                event.status,
            ]
                .filter(Boolean)
                .some((value) => value.toString().toLowerCase().includes(searchKey));

        return statusMatches && searchMatches;
    });
}

handleSearch = (searchKey) => {
    this.setState({ searchKey });
}

handleStatusFilter = (statusFilter) => {
    this.setState({ statusFilter });
}

    render() {
        const filteredEvents = this.getFilteredEvents();
        const statusCounts = this.getStatusCounts();
        const statusFilters = [
            { key: "all", label: "All", count: statusCounts.all },
            { key: "active", label: "Active", count: statusCounts.active },
            { key: "disabled", label: "Disabled", count: statusCounts.disabled },
        ];

        return (
            <Layout>
            
<Helmet>
    <title>Events</title>
</Helmet>
            <div className="contentBody events-page-shell">
                <div className="contentWrapper events-page">
                    <div className="events-page-header">
                        <div>
                            <h2>Events</h2>
                            <p>Manage event definitions, configuration and reporting availability.</p>
                        </div>

                        <div className="events-header-actions">
                            <RoleAccessBadge role="SystemAdmin" />
                            <Button className="events-create-button" variant="primary" onClick={()=>{this.handleCreateNew()}} >
                                <i className="fa fa-plus"></i>
                                Create new
                            </Button>
                        </div>
                    </div>

                    <div className="events-toolbar">
                        <div className="events-search">
                            <i className="fa fa-search"></i>
                            <Form.Control
                                aria-label="Start typing to filter events"
                                onChange={(event) => this.handleSearch(event.target.value)}
                                placeholder="Search events by name, description, type, configuration or status"
                                type="text"
                            />
                        </div>

                        <div className="events-status-filter" role="group" aria-label="Filter events by status">
                            {statusFilters.map((filter) => (
                                <button
                                    className={this.state.statusFilter === filter.key ? "active" : ""}
                                    key={filter.key}
                                    onClick={() => this.handleStatusFilter(filter.key)}
                                    type="button"
                                >
                                    {filter.label}
                                    <strong>{filter.count}</strong>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="eventsTable events-table-shell">
                        <EventTable EventsList={filteredEvents} />
                    </div>
            </div>
            </div>
            </Layout>
        );
    }
}


const mapStateToProps= (state)=>({

    loading:state.loading
    
  })
  const mapDispatchToProps= {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction:setErrorMessage
  
    
  }
  
  export default connect(mapStateToProps,mapDispatchToProps)(Events);
